export const unitsOfMeasure = [
  { id: "ee737b5b-fb3b-418d-9b80-4746540d3afa", name: "g", description: "Gram" },
  { id: "5a163754-79d7-4b17-a926-07e4daa91b74", name: "kg", description: "Kilogram" },
  { id: "addd7e6f-35da-4494-9ca9-db2256bee1ee", name: "Item", description: "An item of a product" },
]
